import { Component } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-faq',
    templateUrl: './faq.component.html',
    standalone: true,
    imports: [RouterModule, MatExpansionModule]
})
export class FaqComponent {
    
}